<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Repair" active>
            <div class="border p-2">
              <div class="row">
                <div class="col-auto">
                  <span class="bg-primary text-white px-3 font-size-26">
                    {{ job.job_number }}</span
                  >
                </div>
                <div class="col">
                  <p class="text-muted mt-2 mb-0" v-if="job.manufacture">
                    {{ job.manufacture.description }} -
                    {{ job.device_type.description }}
                    <span v-if="job.device_model">
                      <br />
                      <strong>{{ job.device_model.code }}</strong> -
                      {{ job.imei_in ? job.imei_in : job.serial_in }}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-md-6">
                <div v-if="job.assessed_by" class="border border-info p-3">
                  <small class="text-info my-2 font-weight-bold"
                    >ASSESSED BY</small
                  ><br />
                  <i class="lni lni-user"></i> {{ job.assessed_by.name }}<br />
                  <small class="text-muted">
                    {{
                      moment(new Date(job.assessed_date)).format(
                        "DD MMM YY, HH:mm"
                      )
                    }}
                  </small>
                </div>
              </div>
              <div class="col-md-6">
                <div
                  v-if="job.repaired_by"
                  class="border border-info p-3 h-100"
                >
                  <small class="text-info my-2 font-weight-bold"
                    >REPAIRED BY</small
                  ><br />
                  <i class="lni lni-user"></i> {{ job.repaired_by.name }}<br />
                </div>
              </div>
            </div>

            <div class="border p-2">
              <div class="row">
                <div class="col-md-6">
                  <small class="text-info my-2 font-weight-bold"
                    >SYMPTOMS</small
                  >
                  <p v-if="job.symptoms_description" class="nl2br">
                    {{ job.symptoms_description }}
                  </p>

                  <div v-for="s in job.symptoms" :key="s.id">
                    {{ s.code }} - {{ s.description }}
                  </div>
                </div>
                <div class="col-md-6">
                  <small class="text-info my-2 font-weight-bold">FAULTS</small>
                  <div v-for="f in job.faults" :key="f.id">
                    {{ f.code }} - {{ f.description }}
                  </div>
                </div>
              </div>
            </div>

            <div class="border p-2">
              <table
                class="table table-sm border"
                v-if="selectedDeviceFaultActionParts.length > 0"
              >
                <tr
                  class="bg-dark text-white font-size-11 font-weight-bold text-uppercase"
                >
                  <td>Fault</td>
                  <td>Action</td>
                  <td>Repaired</td>
                  <td>Replaced</td>
                </tr>
                <tr v-for="l in selectedDeviceFaultActionParts" :key="l.id">
                  <td>
                    {{ l.fault.description }}
                  </td>
                  <td>
                    {{ l.action.description }}
                  </td>
                  <td>
                    <span v-if="l.repair_part_id">
                      {{
                        parts.filter((x) => x.id == l.repair_part_id)[0].code +
                        "-" +
                        parts.filter((x) => x.id == l.repair_part_id)[0]
                          .description
                      }}
                    </span>
                  </td>
                  <td>
                    <span v-if="l.job_part">
                      {{
                        l.job_part.part.code + "-" + l.job_part.part.description
                      }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>

            <div class="border p-2 mb-3">
              <div class="row">
                <div class="col-md-6">
                  <small class="text-info my-2 font-weight-bold"
                    >ACCESORIES</small
                  >

                  <div v-for="s in job.device_accessories" :key="s.id">
                    {{ s.code }} - {{ s.description }}
                  </div>
                </div>
                <div class="col-md-6">
                  <small class="text-info my-2 font-weight-bold"
                    >CHECKLIST</small
                  >
                  <div v-for="c in checklist" :key="c.id">
                    {{ c.description }}
                  </div>
                </div>
              </div>
            </div>

            <span v-if="!loading">
              <b-button variant="warning" @click="handleSubmit('failed')"
                >QC Failed</b-button
              >

              <b-button
                variant="primary"
                @click="confirmQcPassed"
                class="float-right"
                >QC Passed</b-button
              >
            </span>
            <span v-if="loading">
              <b-spinner label="Spinning"></b-spinner>
            </span>
          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

          <b-tab title="Job">
            <job-minimal :id="id"></job-minimal>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import partner from "@/views/modules/partners/show";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";

export default {
  components: {
    partner,
    client,
    jobMinimal,
  },

  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  data() {
    return {
      checklist: [],
      selectedPartRepair: "Repair",
      selectedFault: null,
      selectedAction: null,
      selectedPart: null,
      selectedDeviceFaultActionParts: [],
      availableParts: [],
      parts: [],
      job: {},
      isLoad: false,
      loading: false,
      errors: null,
      submitStatus: null,
      sort: { column: "code", label: "Code Asc", order: "asc" },
      sortOptions: [
        { column: "code", label: "Code Asc", order: "asc" },
        { column: "code", label: "Code Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      sdvpid: 1,
    };
  },

  methods: {
    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await jobRepo.qualityControlCreate(id);
        this.job = data.job;
        this.parts = data.parts;
        this.checklist = data.checklist;

        this.job.job_fault_actions.forEach((jfa) => {
          this.sdvpid = this.sdvpid + 1;

          this.selectedDeviceFaultActionParts.push({
            id: this.sdvpid,
            fault: this.job.faults.filter((x) => x.id == jfa.fault_id)[0],
            action: this.job.faults
              .filter((x) => x.id == jfa.fault_id)[0]
              .actions.filter((x) => x.id == jfa.action_id)[0],
            job_part:
              jfa.part_id != null && jfa.part_replaced == "1"
                ? this.job.job_parts.filter((x) => x.part_id == jfa.part_id)[0]
                : null,
            repair_part_id:
              jfa.part_id != null && jfa.part_replaced == "0"
                ? jfa.part_id
                : null,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    confirmQcPassed() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you have checked all items in the checklist and all device accessories are accounted for.",
          {
            title: "QC PASSED",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirm) => (confirm ? this.handleSubmit("passed") : false))
        .catch((error) => console.log(error));
    },

    async handleSubmit(qc) {
      this.loading = true;
      this.submitStatus = "PENDING";

      try {
        await jobRepo.qualityControlStore({
          id: this.id,
          quality_control: qc,
        });
        this.$emit("qualityControlCreated");
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log(this.errors);
          this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.loading = false;
        this.submitStatus = null;
      }
    },
  },
};
</script>

